import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadDocuments = _resolveComponent("UploadDocuments")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ColumnCorrespondence = _resolveComponent("ColumnCorrespondence")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    flat: "",
    style: {"max-width":"1000px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window, {
        modelValue: _ctx.step,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event)),
        touchless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_UploadDocuments, {
                showFirstPrevious: false,
                documentType: 'ACCOUNTING_PLAN',
                inExtensions: ['csv', 'tsv', 'txt', 'xlsx', 'xls'],
                multiple: false,
                freeTag: false,
                gDrive: true,
                onFileInput: _ctx.onFileChanged,
                onFileDeleted: _ctx.onFileDeleted,
                onTestFileInput: _ctx.onTestFileChanged
              }, null, 8, ["onFileInput", "onFileDeleted", "onTestFileInput"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: 1 }, {
            default: _withCtx(() => [
              (_ctx.step > 0 && _ctx.existingFile)
                ? (_openBlock(), _createBlock(_component_ColumnCorrespondence, {
                    key: 0,
                    ref: "columnComponent",
                    result: _ctx.result,
                    extension: _ctx.extension,
                    actions: _ctx.actions,
                    ruleManager: _ctx.ruleManager,
                    formatColumns: _ctx.formatColumns,
                    onColumnsChosen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChosenColumns($event))),
                    onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.step = 0))
                  }, null, 8, ["result", "extension", "actions", "ruleManager", "formatColumns"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}